import { render, staticRenderFns } from "./Customization.vue?vue&type=template&id=55d3c54f&scoped=true"
import script from "./Customization.vue?vue&type=script&lang=js"
export * from "./Customization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d3c54f",
  null
  
)

export default component.exports